import React from 'react'
import { Image } from '@shared/components/image'
import styled, { DefaultTheme } from 'styled-components'

export function SectionInvestors(): JSX.Element {
	return (
		<ViewRoot>
			<ViewContent>
				<TextTitle>Инвестиции рекомендуют</TextTitle>
				<ViewItem>
					<ImageStyled name='actioner-Alexander-Pharlenkov.png' alt='Александр Фарленков' />
					<TextName>Александр Фарленков</TextName>
					<Text>Основатель Credit.Club</Text>
				</ViewItem>
				<ViewItem>
					<ImageStyled name='actioner-Golodnov.png' alt='Артём Голоднов' />
					<TextName>Артём Голоднов</TextName>
					<Text>Финансовый директор ТАУ Индастриз</Text>
					<Text sub>
						Опыт:
						<br />
						Директор по инвестициям Malltech
						<br />
						Вице-президент Goldman Sachs «Развивающиеся рынки»
						<br />
						Аудитор Ernst &amp; Young
					</Text>
				</ViewItem>
				<ViewItem>
					<ImageStyled name='actioner-Anton-Pharlenkov.jpg' alt='Антон Фарленков' />
					<TextName>Антон Фарленков</TextName>
					<Text>
						Член экспертного совета Banki.ru
						<br />
						Член экспертного совета BestDoctor
					</Text>
					<Text sub>
						Опыт:
						<br />
						Член правления Goldman Sachs Россия
						<br />
						Директор по стратегии «О&apos;КЕЙ Групп»
						<br />
						Советник по коммерческим вопросам на Северном море в Royal Dutch Shell
					</Text>
				</ViewItem>
				<ViewItem>
					<ImageStyled name='actioner-Mironenkov.png' alt='Антон Мироненков' />
					<TextName>Антон Мироненков</TextName>
					<Text>Член правления и управляющий директор Х5 Технологии</Text>
					<Text sub>
						Опыт:
						<br />
						X5 Retail Group PricewaterhouseCoopers — PwC
					</Text>
				</ViewItem>
				<ViewItem last>
					<ImageStyled name='actioner-Arabidi.png' alt='Константин Арабидис' />
					<TextName>Константин Арабидис</TextName>
					<Text>Финансовый директор «О&apos;КЕЙ Групп»</Text>
					<Text sub>
						Опыт:
						<br />
						Аудитор PricewaterhouseCoopers — PwC
					</Text>
				</ViewItem>
			</ViewContent>
		</ViewRoot>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	marginBottom: 60,
	paddingLeft: 16,
	paddingRight: 16,
	textAlign: 'center',
	overflowX: 'auto',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 10,
	textAlign: 'left',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 32,
	},
}))

const ViewContent = styled.div({
	whiteSpace: 'nowrap',
	display: 'inline-block',
})

interface ViewStyledProps {
	last?: boolean
}
const ViewItem = styled.div<ViewStyledProps>(({ theme, last }) => ({
	width: 160,
	marginRight: last ? 0 : 20,
	verticalAlign: 'top',
	display: 'inline-block',
	textAlign: 'left',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		width: 180,
		marginRight: last ? 0 : 35,
	},
}))

const ImageStyled = styled(Image)(({ theme }) => ({
	height: 160,
	width: 160,
	marginBottom: 10,
	borderRadius: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		height: 180,
		width: 180,
	},
}))

const TextName = styled.h3(({ theme }) => ({
	...theme.typography.text16_22,
	fontWeight: 700,
	marginBottom: 4,
	whiteSpace: 'normal',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))

interface TextProps {
	sub?: boolean
}
const Text = styled.p<TextProps>(({ theme, sub = false }) => ({
	whiteSpace: 'normal',
	...theme.typography.text12_16,
	fontWeight: 700,
	marginBottom: 10,
	opacity: sub ? 0.5 : 1,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text14_18,
	},
}))
